import { useState } from 'react'
import { Combobox } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faCheck } from '@fortawesome/free-solid-svg-icons'
import defaultImage from '@/assets/png/stock-product-default.png'
import PropTypes from 'prop-types'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

MySelectWhithSearch.propTypes = {
  dataFilter: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  displayValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
}

export default function MySelectWhithSearch({
  dataFilter,
  value,
  onChange,
  label,
  className,
  displayValue,
  name,
}) {
  const [query, setQuery] = useState('')
  const [selectedItem, setSelectedItem] = useState(
    dataFilter.find((item) => item.id === value)
  )

  const filtered =
    query === ''
      ? dataFilter
      : dataFilter.filter((item) => {
          return item.name.toLowerCase().includes(query.toLowerCase())
        })

  return (
    <Combobox
      as="div"
      className={`${className} w-full`}
      onChange={(selected) => {
        setSelectedItem(selected)
        onChange({ name, value: selected.id })
      }}
      value={value}
    >
      <Combobox.Label className="block text-sm font-medium text-gray-700">
        {label}
      </Combobox.Label>
      <div className="relative mt-1">
        <Combobox.Input
          className={
            'w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10' +
            ' shadow-sm focus:border-gray-500 focus:outline-none focus:ring-1' +
            ' focus:ring-gray-500 sm:text-sm'
          }
          displayValue={() =>
            selectedItem?.name === undefined ? displayValue : selectedItem?.name
          }
          onChange={(e) => setQuery(e.target.value)}
        />
        <Combobox.Button
          className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
          onClick={() => setQuery('')}
        >
          <FontAwesomeIcon
            aria-hidden="true"
            className="h-3.5 w-3.5 text-gray-500"
            icon={faAngleDown}
          />
        </Combobox.Button>
        {filtered?.length > 0 && (
          <Combobox.Options
            className={
              'absolute z-40 mt-1 max-h-40 w-full overflow-auto rounded-md' +
              ' bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm'
            }
          >
            {filtered?.map((item, index) => (
              <Combobox.Option
                className={({ active }) =>
                  classNames(
                    'relative cursor-default select-none py-2 pl-3 pr-9',
                    active ? 'bg-primary text-white' : 'text-gray-900'
                  )
                }
                key={index}
                value={item}
              >
                {({ active, selected }) => (
                  <>
                    <span
                      className={classNames(
                        'flex items-center gap-2 truncate',
                        selected && 'font-semibold'
                      )}
                    >
                      {item?.image && (
                        <img
                          alt={item.imageId !== null ? item.imageId : ''}
                          className="h-8 w-8 rounded-full"
                          src={defaultImage}
                          // src={
                          //   item.image !== null ? item.image.src : defaultImage
                          // }
                        />
                      )}
                      <p className="capitalize">{item.name}</p>
                    </span>
                    {selected && (
                      <span
                        className={classNames(
                          'absolute inset-y-0 right-0 flex items-center pr-4',
                          active ? 'text-white' : 'text-primary'
                        )}
                      >
                        <FontAwesomeIcon
                          aria-hidden="true"
                          className="h-5 w-5"
                          icon={faCheck}
                        />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  )
}
